/**
 * FILE: apps/hub/src/components/ProtectedRoute.tsx
 * PURPOSE: Reusable UI component.
 * AGENT_CONTEXT: Shared component. Keep <200 lines. Extract sub-components if needed.
 * LAST_REVIEWED: 2026-05-07
 */

import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { canAccess, defaultPathByPermissions } from '@/lib/authz'
import { useAuth } from '@/hooks/useAuth'
import { LoadingSpinner } from './LoadingSpinner'

export function ProtectedRoute() {
  const location = useLocation()
  const { identity, status } = useAuth()

  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingSpinner label="Checking session..." />
      </div>
    )
  }

  if (!identity) return <Navigate to="/login" replace />
  if (!canAccess(identity.permissions, location.pathname, identity.roleName)) {
    return <Navigate to={defaultPathByPermissions(identity.permissions, identity.roleName)} replace />
  }

  return <Outlet />
}
